
























import Vue from "vue";
import { AppAnalytics } from "@/analytics";
import { UseModal } from "../modal";
import PlansModal from "@/components/modals/plans-modal/PlansModal.vue";
import { computed } from "@vue/composition-api";
import moment from "moment";
import { SharedState } from "@/common/state";
export default Vue.extend({
  setup() {
    const today = moment(new Date());
    const daysLeft = computed(() => {
      const end_day = moment(
        SharedState.loggedUser.value.trial.endsAt || new Date()
      );
      return Math.abs(today.diff(end_day, "days"));
    });
    const upgrade = () => {
      AppAnalytics.report({
        component: "Upgrade",
        eventName: "Change_plan[Area:Logo, Action:Open]"
      });
      UseModal().show(PlansModal);
    };

    const isOnTrial = computed(
      () =>
        SharedState.loggedUser.value.trial &&
        SharedState.loggedUser.value.trial.active
    );

    return {
      upgrade,
      daysLeft,
      isOnTrial
    };
  }
});
